import { actionConst } from "../constants";

export const updateCapacityKeyboardHeight = (keyboardHeight: number) => {
  return {
    type: actionConst.UPDATE_CAPACITY_KEYBOARD_HEIGHT,
    keyboardHeight,
  };
};
